import type { ApiAreaOfFocus } from '#/api/types/ApiAreaOfFocus';
import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFacetAccordionItem } from '#/modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from '#/modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from '#/modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { SEARCH_COMMON_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchCommonRefinementTypes';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { AREAS_OF_FOCUS_CHECKBOX_OPTIONS } from '#/utils/constants/general/areasOfFocus';

type Props = {
  variant: SearchRefinementVariant;
  excludedAreasOfFocus: ApiAreaOfFocus[];
};

export function OrgAreasOfFocusFacet({ variant, excludedAreasOfFocus }: Props) {
  const { i18n } = useI18n();

  const selectedFacetValues = useSearchFacetSelectedValues('areasOfFocus');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="areasOfFocus"
      icon="globe"
      label={
        <>
          {SEARCH_COMMON_REFINEMENT_LABELS(i18n).areasOfFocus}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="areasOfFocus"
        initialValue={selectedFacetValues}
        options={AREAS_OF_FOCUS_CHECKBOX_OPTIONS(i18n).filter(
          (option) => !excludedAreasOfFocus.includes(option.name),
        )}
        searchable
      />
    </FacetVariant>
  );
}
